import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import * as R from 'ramda';

import { Container } from 'components/shared/container/Container.styled';
import { translate } from 'shared/utils/translate';
import { H2, ParagraphRegular } from 'components/shared/typography';
import {
  SectionComponent,
  SectionFlattenProps,
} from '../section/Section.props';
import * as Styled from './Heading.styled';

const Heading = ({
  components,
  theme,
  intl,
}: WrappedComponentProps & SectionFlattenProps) => {
  const component = (components?.[0] || {}) as SectionComponent;

  const color = theme?.color || '';
  const title = component.title || '';
  const body = component.body || '';

  if (!title) return null;

  return (
    <Styled.Wrapper>
      <Container>
        <H2 color={color}>{translate({ intl, id: title })}</H2>
        {body && (
          <Styled.BodyWrapper>
            <ParagraphRegular color={color}>
              {translate({ intl, id: body })}
            </ParagraphRegular>
          </Styled.BodyWrapper>
        )}
      </Container>
    </Styled.Wrapper>
  );
};

export default injectIntl(Heading);
